/*
 * Copyright (c) 2022. World Wide Generation Ltd
 */

import React from 'react';
import { Button } from 'reactstrap';
import { SurveyModelMinimalUtrv } from '../../../model/surveyData';
import { ScopeQuestionOptionalValue } from '../../../types/surveyScope';
import { Column, Divider } from '../../tracking-list';

interface GroupSelectboxProps {
  questionGroup: { list?: unknown[] },
  questionList: ScopeQuestionOptionalValue[];
  toggleSelectQuestions: (utrvs: SurveyModelMinimalUtrv[]) => void;
  selectedQuestionIds: string[];
}

export const GroupSelectbox = (props: GroupSelectboxProps) => {
  const { questionGroup, questionList, toggleSelectQuestions, selectedQuestionIds } = props;

  if (questionGroup?.list?.length === 0) {
    return null;
  }

  const handleToggleGroup = (e?: React.MouseEvent) => {
    if (e) {
      e.preventDefault();
      e.stopPropagation();
    }
    toggleSelectQuestions(
      questionList
        .map((q) => ({ ...q.utrv, valueType: q.valueType, valueValidation: q.valueValidation }))
        .filter((u) => u !== undefined) as SurveyModelMinimalUtrv[]
    );
  }

  let isSelected = selectedQuestionIds.length > 0;
  let isPartial = false;

  questionList.every(q => {
    if (!q.utrv) {
      return true;
    }
    const found = selectedQuestionIds.includes(q.utrv._id);
    if (found) {
      isPartial = true;
    } else {
      isSelected = false;
      if (isPartial) {
        // Early exit as we already know it has to be a partial
        return false;
      }
    }
    return true;
  });

  const getIcon = () => {
    if (isSelected) {
      return 'fa-solid fa-square-check text-ThemeAccentMedium';
    }
    if (isPartial) {
      return 'fa-solid fa-square-minus text-ThemeAccentMedium'
    }
    return 'fa-light fa-square text-ThemeNeutralsDark'
  }

  return (
    <div className='d-flex'>
      <Divider />
      <Column className='question-list__select-box'>
        <Button color='link' onClick={handleToggleGroup} className='p-0'>
          <i className={getIcon()} />
        </Button>
      </Column>
    </div>
  );
}
